import React from "react";

function Dashboard() {
  return <div>Welcome to the Dashboard</div>;
}

export default Dashboard;
